export default __webpack_public_path__ + "static/media/1.95733c0f.png";